import { render, staticRenderFns } from "./CopyCatalogModal.vue?vue&type=template&id=2bbcbddc"
import script from "./CopyCatalogModal.vue?vue&type=script&lang=js"
export * from "./CopyCatalogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports